var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContributionPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.33a8.333 8.333 0 110-16.666 8.333 8.333 0 110 16.667zm0-1.666a6.666 6.666 0 100-13.333 6.666 6.666 0 000 13.333zm.833-5.833h2.5v1.666h-2.5v1.667H9.166v-1.667h-2.5v-1.666h2.5v-.834h-2.5V8.331h2.155L7.053 6.563l1.18-1.179 1.766 1.768 1.768-1.768 1.179 1.18-1.768 1.767h2.155v1.666h-2.5v.834z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContributionPrice;